// extracted by mini-css-extract-plugin
export default {"coins_watching":"CoinsWatching_coins_watching__AWs6n"};